import { errorMessageFrom } from "../../../../../../../../utils/formErrors";
import React, {useState} from 'react';
import TopBar from '../../../../../../../../component/TopBar';
import {Autocomplete, Box, CircularProgress, Stack, TextField} from '@mui/material';
import ActiveBar from '../../../../../../../../component/PolicyNavbarUpdated';
import BtnSecondary from "../../../../../../../../component/SecondaryButton";
import BtnPrimary from "../../../../../../../../component/PrimaryButton";
import ErrorMsg from '../../../../../../../../component/ErrorMsg';
import FormField from '../../../../../../../../component/Formfield';
import { WizardCard, FormSection, FieldGrid, FieldLabel, WizardActions } from '../../../../../../../../component/wizard';
import { tokens } from '../../../../../../../../theme';
import { useNavigate } from 'react-router';
import { createShift } from "../../../../../../../../services/shift";
import SetShift from './SetShift';
import { getLegalUnitList } from "../../../../../../../../services/globalData";
import { useNotify } from '../../../../../../../../component/NotificationProvider';

const initialDayState = {
  isHoliday: true,
  startTime: undefined,
  endTime: undefined,
  breakTime:0,
  hoursMetric: "gross",
  minHalfDayHours: 0,
  minFullDayHours: 0,
  maxHalfDayHours: 0,
  maxFullDayHours: 0,
};

const ShiftDetails = () => {

    const [apiCall,setApiCall]=useState(false);
    const navigate = useNavigate();
    const notify = useNotify();

    const [shiftData,setShiftData] = useState({
      code:"",
      name:"",
      days: Array(7).fill(initialDayState),
      legalUnit:"",
      doesScheduleVary: false,
      flexibleWorkingHours: false,
    });

    const [validationErrors, setValidationErrors] = useState({code:"",name:"", legalUnit:""});
    const [workingDays, setWorkingDays] = useState([]);
    const [holidays, setHolidays] = useState([]);
    const [error,setError]=useState("");
    const [selectedLocation, setSelectedLocation]=useState("");
    const legalUnits = getLegalUnitList()?.map(legalUnit => ({
      id: legalUnit?._id,
      label: legalUnit?.name
    }));


    const onLocationChange = (value) =>{
      setSelectedLocation(value);
      setShiftData(prevState => ({
        ...prevState,
        legalUnit: value?.id
      }));
    }
  
   const handleNextClick = async() => {
        const errors ={};
  
        if (!shiftData.code) errors.code="Code is required"
        if (!shiftData.name) errors.name="Name is required"
        if (!shiftData.legalUnit) errors.legalUnit="Location is required"

        if (Object.keys(errors).length > 0) {
          setValidationErrors(errors);
          return;
        }

        setApiCall(true);
        try {
          const res = await createShift(shiftData);
          if(res.success){
            notify.success("Shift created successfully");
            navigate("/app/shift/new/assign-shift",{state:{policyId: res?.data?._id}});
          }else{
            setError("Shift Creation Failed");
            notify.error(errorMessageFrom(res, "Shift creation failed"));
          }
        } catch (error) {
            notify.error(error?.message || "Something went wrong creating the shift");
        } finally {
            setApiCall(false);
        }
    };
  
    const handleChange = (field, value) => {
      const updatedValue = field === "code" ? value?.toUpperCase() : value;
      setShiftData(prevState => ({...prevState, [field]: updatedValue}));
      setValidationErrors(prevState => ({...prevState, [field]: ""}));
      setError("");
    };
  
  return (
    <Box sx={{width:"100%"}}>
        <TopBar
            MainHeading={"Shift Creation"}
            breadcrumbs={[{label:"Create Shift", href:""},{label:"Shift Details", href:""}]}
        />
        <WizardCard>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: "1.5rem" }}>
                <ActiveBar page="shift" active={["Shift Details"]} />
                <BtnSecondary to={"/app/shift/listing"} sx={{ borderRadius: "8px" }}>
                    Back
                </BtnSecondary>
            </Stack>

            <FormSection title="Shift details" description="Give the shift a unique code and a recognizable name.">
                <FieldGrid>
                    <Box>
                        <FieldLabel required>Shift Code</FieldLabel>
                        <FormField type="text" value={shiftData.code} validation={validationErrors.code}
                            placeholder="e.g. E099" onChange={(e) => handleChange('code', e.target.value)} />
                    </Box>
                    <Box>
                        <FieldLabel required>Name of the Shift</FieldLabel>
                        <FormField type="text" value={shiftData.name} validation={validationErrors.name}
                            onChange={(e) => handleChange('name', e.target.value)} />
                    </Box>
                </FieldGrid>
            </FormSection>

            <SetShift
               shiftData={shiftData}
               setShiftData={setShiftData}
               workingDays={workingDays}
               setWorkingDays={setWorkingDays}
               holidays={holidays}
               setHolidays={setHolidays}
               initialDayState={initialDayState}
            />

            <FormSection title="Shift location" description="The legal entity this shift belongs to.">
                <Box sx={{ maxWidth: "28rem" }}>
                    <FieldLabel required>Location</FieldLabel>
                    <Autocomplete
                        options={legalUnits}
                        size="small"
                        value={selectedLocation}
                        onChange={(e,newValue)=>onLocationChange(newValue)}
                        sx={{
                          '& .MuiInputBase-root':{ borderRadius: '10px', fontSize: '0.9375rem', fontWeight:"400", color: tokens.text, minHeight:"2.75rem" },
                          "& .MuiOutlinedInput-notchedOutline":{ borderColor: tokens.border },
                          "&:hover .MuiOutlinedInput-notchedOutline":{ borderColor: tokens.textMuted },
                          "& .Mui-focused .MuiOutlinedInput-notchedOutline":{ borderColor: tokens.accent },
                        }}
                        renderInput={(params)=><TextField {...params} placeholder="Select location" />}
                    />
                    <ErrorMsg>{validationErrors?.legalUnit}</ErrorMsg>
                </Box>
            </FormSection>

            <ErrorMsg>{error}</ErrorMsg>
            <WizardActions>
                <BtnPrimary
                    onClick={handleNextClick}
                    sx={{ height: "3rem", px: "2.5rem", borderRadius: "10px" }}
                    disabled={apiCall}
                >
                    {apiCall?<CircularProgress size={"1.25rem"}/>:"Next"}
                </BtnPrimary>
            </WizardActions>
        </WizardCard>
    </Box>
    )
}

export default ShiftDetails;